import React, { useState, useEffect } from 'react';
import { 
  Stack, 
  Text, 
  Button, 
  Textarea, 
  Group
} from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';

interface CaptionSectionProps {
  caption: string;
  onSave: (caption: string) => void;
}

export const CaptionSection: React.FC<CaptionSectionProps> = ({ caption: initialCaption, onSave}) => {
  const [caption, setCaption] = useState(initialCaption || '');
  
  useEffect(() => {
    setCaption(initialCaption || '');
  }, [initialCaption]);

  return (
    <Stack gap={0} style={{flex: 1}}>
      <Group align='end' justify="space-between">
        <Text fw={500} size={'sm'}>Caption</Text>
        <Button
          radius={'xl'}
          size="compact-xs"
          variant="light"
          color="blue"
          rightSection={<IconSparkles size={16}/>}
        >
          Generate
        </Button>
      </Group>
      <Textarea
        mt={5}
        placeholder="Add a caption to describe this image"
        value={caption}
        onChange={(e) => {
          const newCaption = e.currentTarget.value;
          setCaption(newCaption);
          onSave(newCaption);
        }}
        autosize
        minRows={3}
      />
    </Stack>
  );
};
